import { ssrApi } from 'api/ssr';
import { Props, SlotPage } from 'components/template/slot-page';
import { ISlot } from 'constants/types';
import { ParsedUrlQuery } from 'querystring';
import {
  isValidEntity,
  notFoundResult,
  unwrapEntity,
} from 'utils/ssr-not-found';

export default function Register({
  slot,
  slotProvider,
  forRealMoneyCasinos,
}: Props) {
  return (
    <SlotPage
      slot={slot}
      slotProvider={slotProvider}
      forRealMoneyCasinos={forRealMoneyCasinos}
    />
  );
}

export async function getServerSideProps({ query }: { query: ParsedUrlQuery }) {
  const { id } = query;

  const slot = (await ssrApi.slots.getById(id?.toString())) as ISlot | null;

  if (!isValidEntity(slot)) {
    return notFoundResult();
  }

  const resolvedSlot = unwrapEntity(slot)!;

  const slotProvider = await ssrApi.providers.getById(
    resolvedSlot.provider_id ?? ''
  );
  const forRealMoneyCasinos = await ssrApi.casinos.casinosForRealMoney();

  return {
    props: {
      slot: resolvedSlot,
      slotProvider: unwrapEntity(slotProvider),
      forRealMoneyCasinos: forRealMoneyCasinos?.results ?? [],
    },
  };
}
